export default __webpack_public_path__ + "static/media/stadium.58b72b4a.svg";